module.exports = __webpack_public_path__ + "img/dark-cloudy-storm.c0bbc8aa.svg";